<template>
  <div class="home-router">
    <!-- 如果 abTestInfo 还没有加载，显示加载状态 -->
    <div v-if="!abTestInfoLoaded" class="loading-container">
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>正在加载...</p>
      </div>
    </div>

    <!-- 根据 abTestInfo 的 strategy 决定显示哪个组件 -->
    <NewHome v-else-if="abTestInfo && abTestInfo.strategy === 'A'" />
    <Home v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Home from "@/views/home/index.vue";
import NewHome from "@/views/newHome/index.vue";

export default {
  name: "HomeRouter",
  components: {
    Home,
    NewHome,
  },
  computed: {
    ...mapGetters(["abTestInfo"]),
    abTestInfoLoaded() {
      // 检查 abTestInfo 是否已经加载
      return this.abTestInfo && Object.keys(this.abTestInfo).length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-router {
  width: 100%;
  height: 100%;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.loading-spinner {
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-spinner p {
  color: #666;
  font-size: 14px;
  margin: 0;
}
</style>
